module.exports = __webpack_public_path__ + "img/icon-note-light.b3b1daf5.svg";